import { useCallback } from 'react';

import confirm from '../../helpers/confirm';

import useFormulaArchive from 'hooks/formulas/useFormulaArchive';
import useFormulaDelete from 'hooks/formulas/useFormulaDelete';

import { FormulaDetailModel } from '../../models/formula.model';

interface UseFormulaActionsProps {
    formula: FormulaDetailModel;
    onCloseDrawer?: () => void;
    back?: () => void;
}

export function useFormulaActions({
    formula,
    onCloseDrawer,
    back,
}: UseFormulaActionsProps) {
    const deleteFormula = useFormulaDelete();
    const archiveFormula = useFormulaArchive();

    const handleArchive = useCallback(async () => {
        const confirmed = await confirm(
            'Are you sure you want to archive this message?',
            undefined,
            undefined,
            undefined,
            'Archive',
        );

        if (formula?.id && confirmed) {
            archiveFormula.mutate(formula.id, {
                onSuccess: () => {
                    archiveFormula.reset();
                    onCloseDrawer?.();
                },
                onError: () => {
                    alert('Unable to archive');
                },
            });
        }
    }, [archiveFormula, formula, onCloseDrawer]);

    const handleDelete = useCallback(async () => {
        const confirmed = await confirm(
            'Are you sure you want to delete this message?',
            'warning',
            undefined,
            undefined,
            'Delete message',
        );
        if (confirmed) {
            deleteFormula.mutate(formula.id, {
                onSuccess: () => {
                    deleteFormula.reset();
                    onCloseDrawer?.();
                    back?.();
                },
            });
        }
    }, [formula, deleteFormula, onCloseDrawer, back]);

    return {
        handleArchive,
        handleDelete,
        isArchiving: archiveFormula.isPending,
        isDeleting: deleteFormula.isPending,
    };
}
